import React from 'react'
import styled from 'styled-components'

const swatchSize = 12
const swatchSpace = 1
export const Key = ({
  entries,
}: {
  entries?: {
    type:
      | 'line'
      | 'rect'
      | 'none'
      | 'rect-pattern'
      | 'rect-multi'
      | 'circle'
      | 'cross'
    label: string | JSX.Element
    color: string | string[]
  }[]
}) => {
  return (
    <StyledKey>
      {entries &&
        entries.map((m, i) => {
          return (
            <Entry key={'Key_' + i}>
              <div className='swatch'>
                {m.type === 'rect' ? (
                  <SwatchShape color={m.color as string} />
                ) : m.type === 'rect-pattern' ? (
                  <SwatchShapePattern color={m.color as string} />
                ) : m.type === 'line' ? (
                  <SwatchLine color={m.color as string} />
                ) : m.type === 'rect-multi' ? (
                  <SwatchShapeMulti color={[m.color as string]} />
                ) : m.type === 'circle' ? (
                  <SwatchCircle color={m.color as string} />
                ) : m.type === 'cross' ? (
                  <SwatchCross color={m.color as string} />
                ) : (
                  <SwatchNone />
                )}
              </div>
              <div className='label'>{m.label}</div>
            </Entry>
          )
        })}
    </StyledKey>
  )
}

const StyledKey = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75em;
  margin-bottom: 0.5em;
  flex: 0 0 15%;
  width: 100%;
  @media only screen and (max-width: 711px) {
    /* flex: 0 0 100%; */
    padding-left: 2rem;
    padding-right: 2rem;
    width: calc(100% - 4rem);
  }
`

const Entry = styled.div`
  font-size: 15px;
  display: flex;
  align-items: flex-start;
  flex: 0 0 calc(50% - 0.5em);
  line-height: 1.4em;
  .label {
    flex: 1 1 100%;
    color: var(--text-color);
    span {
      white-space: nowrap;
    }
  }
  .swatch {
    flex: 0 0 ${swatchSize + 'px'};
    margin-right: 0.5em;
  }
  @media only screen and (max-width: 711px) {
    font-size: 13px;
    flex: 0 0 100%;
  }
`

const SwatchShapeMulti = ({ color }: { color: string[] }) => {
  return (
    <svg width={swatchSize * 2 + swatchSpace} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color[0]} />
      <rect
        x={swatchSize + swatchSpace}
        width={swatchSize}
        height={swatchSize}
        fill={color[1]}
      />
    </svg>
  )
}
const SwatchShape = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <rect width={swatchSize} height={swatchSize} fill={color} />
    </svg>
  )
}
const SwatchCircle = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <circle
        cx={swatchSize / 2}
        cy={(swatchSize * 1.1) / 2}
        r={(swatchSize * 0.8) / 2}
        fill={color}
      />
    </svg>
  )
}
const SwatchShapePattern = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <pattern
        id='diagonalHatch'
        patternUnits='userSpaceOnUse'
        width='4'
        height='4'
        style={{ transform: 'scale(1.5)' }}
      >
        <path
          d='M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
          style={{ stroke: color, strokeWidth: 1 }}
        />
      </pattern>
      <rect width={swatchSize} height={swatchSize} fill='url(#diagonalHatch)' />
    </svg>
  )
}
const SwatchLine = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <line
        x2={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={4}
      />
    </svg>
  )
}
const SwatchCross = ({ color }: { color: string }) => {
  return (
    <svg width={swatchSize} height={swatchSize}>
      <line
        x2={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={3}
      />
      <line
        x1={swatchSize}
        y1={swatchSize}
        y2={0}
        stroke={color}
        strokeWidth={3}
      />
    </svg>
  )
}
const SwatchNone = () => {
  return <svg width={swatchSize} height={swatchSize}></svg>
}
